module.exports = __webpack_public_path__ + "static/media/card_03.190ed53c.png";